module.exports = "/_next/static/images/water-distribution-expertise-7ebe843ba53b9f8d2d31f1cee7c24249.webp";